module.exports = __webpack_public_path__ + "img/轻型仓储.0b5cff30.png";